let locationsMap = []
let ports = [];

function PortsRepository() {}

PortsRepository.prototype.initialize = function({ ports: rawPorts }) {
  rawPorts.forEach(location => {
    locationsMap[location.LocationAbbr] = {
      ...location,
      short: location.short || location.alias,
    }
  })

  ports = rawPorts.map(({ LocationAbbr, alias }) => ({
    portCode: LocationAbbr,
    portName: alias,
  }))
}

PortsRepository.prototype.location = function(abbr) {
  return locationsMap[abbr]
}

PortsRepository.prototype.locationName = function(abbr) {
  return (locationsMap[abbr] && locationsMap[abbr].alias) || abbr
}

PortsRepository.prototype.getPorts = () => ports

export default new PortsRepository()
